import { useNavigate } from "react-router";

const TableOptions = (element, inscrits) => {
	// const { enqueueSnackbar } = useSnackbar();
	const navigate = useNavigate();

	const options = {
		enableNestedDataAccess: ".",
		filterType: "checkbox",
		selectableRows: "none",
		rowsPerPage: 15,
		rowsPerPageOptions: [10, 15, 20],
		searchOpen: true,
		onRowClick: (row) => {
			navigate("/admin/" + element + "/" + row[0]);
		},
		onDownload: (buildHead, buildBody, columns, data) => {
			const alteredData = data?.map((row, index) => ({
				index,
				data: row?.data?.map((field, index) => {
					// console.log(field, columns[index]);
					if (columns[index].customBodyRender) {
						if (columns[index]?.name === "estat") {
							return field?.nom;
						} else {
							return columns[index].customBodyRender(field);
						}
					}
					if (columns[index].customBodyRenderLite) {
						const ins = inscrits.find((i) => i.id === field);
						return ins?.preu + "€";
					}
					return field;
				}),
			}));
			return `${buildHead(columns)}${buildBody(alteredData)}`.trim();
		},
		textLabels: {
			body: {
				noMatch: "No hi han entrades",
				toolTip: "Ordenar",
				columnHeaderTooltip: (column) => `${"Ordenat per"} ${column.label}`,
			},
			pagination: {
				next: "Següent pàgina",
				previous: "Pàgina anterior",
				rowsPerPage: "Files per pàgina:",
				displayRows: "de", // 1-10 of 30
			},
			toolbar: {
				search: "Cercar",
				downloadCsv: "Descarregar CSV",
				print: "Imprimir",
				viewColumns: "Veure columnes",
				filterTable: "Filtrar taula",
			},
			filter: {
				title: "FILTRES",
				reset: "resetejar",
				all: "Tots",
			},
			viewColumns: {
				title: "Mostrar columnes",
			},
			selectedRows: {
				text: "Fila/es eliminades",
				delete: "Eliminar",
			},
		},
	};
	return options;
};

export default TableOptions;
